import { render, staticRenderFns } from "./ArrayedPhoneField.vue?vue&type=template&id=710b99c2&"
import script from "./ArrayedPhoneField.vue?vue&type=script&lang=js&"
export * from "./ArrayedPhoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports